import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { OkObject } from '@it2go/types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    DataInterfaceVersionGridObject,
    DataInterfaceVersionObject,
} from '@libs/types/src/services/object-type/vzp/datainterface-version.object';
import {
    DataInterfaceVersionCreateInput,
} from '@libs/types/src/services/input-type/vzp/datainterface-version.create-input';
import {
    DataInterfaceVersionUpdateInput,
} from '@libs/types/src/services/input-type/vzp/datainterface-version.update-input';

@Injectable({ providedIn: 'root' })
export class DataInterfaceVersionGqlService extends GqlServiceV2 {

    public async getDataInterfaceVersions(input: GridInput, fragment: string) {
        return this.query<DataInterfaceVersionGridObject>(
            `
                query($input: GridInput) {
                    dataInterfaceVersion {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async createDataInterfaceVersion(
        input: DataInterfaceVersionCreateInput,
        fragment: string,
    ) {
        return this.mutate<DataInterfaceVersionObject>(
            `
                mutation($input: DataInterfaceVersionCreateInput!) {
                    dataInterfaceVersion {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async updateDataInterfaceVersion(
        input: DataInterfaceVersionUpdateInput,
        fragment: string,
    ) {
        return this.mutate<DataInterfaceVersionObject>(
            `
                mutation($input: DataInterfaceVersionUpdateInput!) {
                    dataInterfaceVersion {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async deleteDataInterfaceVersion(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    dataInterfaceVersion {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
